module.exports = __webpack_public_path__ + "images/bug_light_blue_large_6e3d46a3b7124cd82d2cab50fb438b3a.png";